
import { defineComponent } from 'vue';
import type { PropType } from 'vue';
import type { types } from '../../api_types';
import T from '../../lang';
import * as ui from '../../ui';
import * as time from '../../time';

import omegaup_Markdown from '../Markdown.vue';

export default defineComponent({
  name: 'Notification',
  components: {
    'omegaup-markdown': omegaup_Markdown,
  },
  props: {
    notification: {
      type: Object as PropType<types.Notification>,
      required: true,
    },
  },
  computed: {
    iconUrl(): string {
      if (this.notification.contents.body) {
        return this.notification.contents.body.iconUrl;
      }

      switch (this.notification.contents.type) {
        case 'badge':
          return `/media/dist/badges/${this.notification.contents.badge}.svg`;
        case 'demotion':
          if (this.notification.contents.status === 'banned') {
            return '/media/banned.svg';
          }
          return '/media/warning.svg';
        case 'general_notification':
          return '/media/email.svg';
        default:
          return '/media/info.png';
      }
    },

    text(): string {
      switch (this.notification.contents.type) {
        case 'demotion':
          return this.notification.contents.message || '';
        case 'general_notification':
          return this.notification.contents.message || '';
        default:
          return '';
      }
    },

    notificationMarkdown(): string {
      if (this.notification.contents.body) {
        return ui.formatString(
          T[this.notification.contents.body.localizationString],
          this.notification.contents.body.localizationParams,
        );
      }
      switch (this.notification.contents.type) {
        case 'badge':
          return ui.formatString(T.notificationNewBadge, {
            badgeName: T[`badge_${this.notification.contents.badge}_name`],
          });
        default:
          return '';
      }
    },

    url(): string {
      if (this.notification.contents.body) {
        return this.notification.contents.body.url;
      }

      switch (this.notification.contents.type) {
        case 'general_notification':
          return this.notification.contents.url || '';
        case 'badge':
          return `/badge/${this.notification.contents.badge}/`;
        case 'demotion':
          // TODO: Add link to problem page.
          return '';
        default:
          return '';
      }
    },

    date(): string {
      return time.formatDateLocalHHMM(this.notification.timestamp);
    },
  },
  methods: {
    handleClick(): void {
      if (this.url) {
        this.$emit('remove', this.notification, this.url);
      }
    },
  },
});
